function getUserAgent(req) {
  if (req) {
    return req.useragent.source
  }

  return navigator.userAgent
}

function iOS(req) {
  if (req) {
    const { isiPad, isiPod, isiPhone } = req.useragent

    return isiPad || isiPod || isiPhone
  }

  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

function android(req) {
  if (req) {
    return req.useragent.isAndroid
  }

  return /(android)/i.test(navigator.userAgent)
}

function getMobile(useragent) {
  return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    useragent
  )
}

function mobile(req) {
  if (req) {
    return req.useragent.isMobile
  }

  return getMobile(navigator.userAgent)
}

function desktop(req) {
  if (req) {
    return req.useragent.isDesktop
  }

  return !getMobile(navigator.userAgent)
}

export default function getDeviceInfo(req) {
  const userAgent = getUserAgent(req)

  return {
    isMobile: mobile(req),
    isDesktop: desktop(req),
    isAndroid: android(req),
    isIOS: iOS(req),
    isApp: userAgent.includes('TicketSwap_MobileApp'),
  }
}
